import React from 'react'
import '../../../style.css'

const BackSpaceGain = ({ formData }) => {
  return (
    <div className="steps-diagnosis-container">
      <p className="fw-bold m-0 ms-1">Ganancia de espacio anterior</p>
      <hr className="mt-2 mb-0" />
      <div className="d-flex flex-column">
        <div className="improve-overjet-container">
          <div className="d-flex justify-content-between">
            <div className="w-100">
              <p className="mb-0">Proinclinación (con torque)</p>
              <hr className="mt-1 me-4" />
              <div>
                <input
                  type="radio"
                  className="mt-2 inputColor"
                  name="proinclination"
                  disabled
                  checked={formData?.with_inclination == 1 && true}
                />
                <label className="ms-2">Si</label>
              </div>
              <div>
                <input
                  type="radio"
                  className="mt-2 inputColor"
                  name="proinclination"
                  disabled
                  checked={formData?.with_inclination == 2 && true}
                />
                <label className="ms-2">Solo si es necesario</label>
              </div>
              <div>
                <input
                  type="radio"
                  className="mt-2 inputColor"
                  name="proinclination"
                  disabled
                  checked={formData?.with_inclination == 3 && true}
                />
                <label className="ms-2">Nada</label>
              </div>
            </div>
            <div className="w-100">
              <p className="mb-0">Protusión (sin torque)</p>
              <hr className="mt-1" />
              <div>
                <input
                  type="radio"
                  className="mt-2 inputColor"
                  name="protusion"
                  disabled
                  checked={formData?.without_inclination == 1 && true}
                />
                <label className="ms-2">Si</label>
              </div>
              <div>
                <input
                  type="radio"
                  className="mt-2 inputColor"
                  name="protusion"
                  disabled
                  checked={formData?.without_inclination == 2 && true}
                />
                <label className="ms-2">Solo si es necesario</label>
              </div>
              <div>
                <input
                  type="radio"
                  className="mt-2 inputColor"
                  name="protusion"
                  disabled
                  checked={formData?.without_inclination == 3 && true}
                />
                <label className="ms-2">Nada</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      {formData?.other_inclination && (
        <>
          <p className="mt-3">Otras:</p>
          <div className="step-text-area w-100 overflow-scroll">
            {formData?.other_inclination}
          </div>
        </>
      )}
    </div>
  )
}

export default BackSpaceGain
